module.exports = "/images/side-settings.svg?02088e2f26e5f70ae29a4bbaa47f92de";